// @flow
/* eslint-disable react/no-multi-comp */
import * as React from 'react';
import type { LoadingProps } from 'react-loadable';

function Error({ error }: {| error: Error |}) {
  return <div>Error loading the component: {error.toString()}</div>;
}

/**
 * The component that should be shown when a page is waiting to load, use it
 * with react-loadable
 *
 * @example
 * import Loadable from 'react-loadable';
 * import { PageLoading } from 'components/atoms/';
 *
 * Loadable({ ..., loading: PageLoading })
 */
function PageLoading(props: LoadingProps) {
  if (props.error) {
    return <Error error={props.error} />;
  }
  return null;
}

export default PageLoading;



// WEBPACK FOOTER //
// ./src/components/common/loader/PageLoading.js